module.exports = {"id":"223740","name":"Eguaras","rating":"71","photo":"./data/images/photos/1/223740.png","club":{"name":"Real Saragosse","logo":"./data/images/clubs/RealSaragosse.png"},"positions":["MDC","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Eguaras0.json
// module id = 1197
// module chunks = 0